import axios from 'axios';

const API_URL = '/api/security';

// 审计日志分页查询
// params: { eventType, identity, ip, hours, page, limit }
export const getAuditLogs = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/audit`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取审计日志失败' };
  }
};

// 可疑IP聚合分析(同IP多凭证/拒绝密集)
export const getSuspiciousIps = async (hours = 24) => {
  try {
    const response = await axios.get(`${API_URL}/suspicious`, { params: { hours } });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取可疑IP分析失败' };
  }
};

// 清理过期审计日志
export const cleanupAudit = async (days = 30) => {
  try {
    const response = await axios.delete(`${API_URL}/audit/cleanup`, { params: { days } });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '清理审计日志失败' };
  }
};
